// extracted by mini-css-extract-plugin
export default {"code-container":"styles_code-container__y3VXK","code-highlighted":"styles_code-highlighted__DOUEE","copy-button":"styles_copy-button__rOPQ9"};